
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const TOKEN_LOGIN = 'TOKEN_LOGIN';
export const SET_SITE = 'SET_SITE';



// WEBPACK FOOTER //
// ./src/types/login.js